import React from 'react'

export default function ContenedorPrincipal(props) {
    return <div className={`p-grid  ${props.extra ? props.extra : ""} `}>
        {props.children}
    </div>
}
